import { Record, Map } from 'immutable';
import { fetchIntakeFormActions, getFormActions, submitIntakeFormActions } from './intake.actions';
import * as api from '../api';

/**
 * @property {Map<string, api.ApiCallState>} intakeForms intake forms indexed by the id of the intake form
 * @property {Map<string, api.ApiCallState>} previewForms intake form preview indexed by the id of the intake form
 * @property {Map<string, api.ApiCallState>} formSubmission state of form submission indexed by the id of the intake form
 * @property {NewAnswersState} newAnswersState the state of answers being entered on the intake form
 * @property {Map<string, api.ApiCallState>} zipAutoFill state of zipAutoFill indexed by the id of the intake form
 */
export const IntakeState = Record({
  intakeForms : Map({}),
  previewForms: Map({}),
  formSubmission: Map({}),
});

export const intakeReducer = (initialState = new IntakeState(), action) => {

  var state = initialState;

  if(action.id) {
    state = state.setIn(['intakeForms', action.id],
      api.apiCallReducer(state.getIn(['intakeForms', action.id]), action, fetchIntakeFormActions));

    state = state.setIn(['previewForms', action.id],
      api.apiCallReducer(state.getIn(['previewForms', action.id]), action, getFormActions));

    state = state.setIn(['formSubmission', action.id],
      api.apiCallReducer(state.getIn(['formSubmission', action.id]), action, submitIntakeFormActions));
  }

  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/intake/intake.reducer.js